import { render } from "./TermsOfUse.vue?vue&type=template&id=7ba39ffa"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"

import "./TermsOfUse.vue?vue&type=style&index=0&id=7ba39ffa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__